import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
Vue.use(VModal)

// Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  timeout: 2500,
  hideProgressBar: true,
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
